import { snakeCase } from 'lodash';

import { GENERATION_TOOL, getToolTitle } from 'src/data/generationTool';
import { isLongFormEditorType } from 'src/data/project';
import { PROMPT_SUB_TEMPLATE_ID } from 'src/data/template';

import { INVALID_TOOLS, PROMPT_TOOLS } from './const';

export const extractToolList = ({ templates, editorType }) => {
  if (isLongFormEditorType(editorType)) {
    return getLongFromToolList(templates);
  }

  return getShortFormToolList(templates);
};

export const extractTemplate = ({ tool, templates, toolList, editorType }) => {
  if (isLongFormEditorType(editorType)) {
    return extractLongFormTemplate(tool, templates);
  }

  return extractSubTemplate(tool, toolList, templates) || extractPromptTemplate(tool, toolList);
};

const getShortFormToolList = (templates) => {
  const toolList = { ...PROMPT_TOOLS, ...INVALID_TOOLS };
  if (!templates || !templates.length) return toolList;

  templates.forEach(({ id, name }) => {
    const key = snakeCase(name);

    toolList[key] = `${name} #${id}`;
  });

  return toolList;
};

export const getLongFromToolList = (templates) => {
  if (!templates || !templates.length) return INVALID_TOOLS;

  const toolList = templates.reduce((acc, { id, name }) => {
    const key = snakeCase(name);

    acc[key] = `${name} #${id}`;
    return acc;
  }, {});

  return { ...toolList, ...INVALID_TOOLS };
};

const extractSubTemplate = (tool, toolList, templates) => {
  if (!tool) return null;

  const toolDescription = toolList[tool];
  if (!toolDescription) return null;

  const subTemplateId = toolDescription.match(/#(\d+)/)?.[1];
  if (!subTemplateId) return null;

  return templates?.find(({ id }) => id === subTemplateId);
};

const extractLongFormTemplate = (tool, templates) => {
  if (!tool) return null;

  const template = templates.find((template) => snakeCase(template.name) === tool);
  if (!template) return null;

  return {
    ...template,
    generationTool: GENERATION_TOOL.customMultiPrompt,
  };
};

const extractPromptTemplate = (tool, toolList) => {
  if (!tool) return null;

  const toolDescription = toolList[tool];
  if (!toolDescription) return null;

  const generationTool = toolDescription.match(
    new RegExp(`^(.*)\\s+#${PROMPT_SUB_TEMPLATE_ID}$`)
  )[1];
  if (!generationTool) return null;

  return {
    id: PROMPT_SUB_TEMPLATE_ID,
    generationTool,
    name: `${getToolTitle(generationTool)} - Prompt`,
  };
};

export const isPromptInvalid = (tool) => {
  return tool ? Boolean(INVALID_TOOLS[tool]) : false;
};
